<app-workspace-master-detail [detailOpen]="detailOpen">
  <app-leads-board workspace-master></app-leads-board>
  <div workspace-detail class="workspace-page--full">
    <router-outlet (deactivate)="reviewClosed($event)"></router-outlet>
  </div>
</app-workspace-master-detail>
